// removed by extract-text-webpack-plugin
module.exports = {"app":"app__app--a29a841a","appBody":"app__appBody--a2fb2a9a","directions":"app__directions--8faa0caf","mobile":"app__mobile--1bfa0a8e","fansidedLogo":"app__fansidedLogo--abb2ceb9","icons":"app__icons--2f10f09d","easterEgg":"app__easterEgg--125a4db8","easterEggText":"app__easterEggText--a763c622"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/layout/app.scss
// module id = 32
// module chunks = 0